import React, { useState, useEffect } from 'react';
import styles from '../PageLayoutAuth.module.scss';
import cx from 'classnames';

export interface Props {
  className?: string;
  country?: string;
}

const PageLayoutAuthBg: React.FC<Props> = ({ className, country = 'de' }) => {
  const bgWhitelist = [
    'ar',
    'at',
    'be',
    'br',
    'ca',
    'cn',
    'cz',
    'de',
    'fr',
    'gb',
    'hu',
    'in',
    'it',
    'jp',
    'lt',
    'nl',
    'pl',
    'ru',
    'ua',
    'us',
  ];
  const localCountry = bgWhitelist.includes(country) ? country : 'de';

  const [jpgSrc, setJpgSrc] = useState();
  const [webpSrc, setWebpSrc] = useState();
  const [avifSrc, setAvifSrc] = useState();

  // import images
  useEffect(() => {
    import(`../../../../../assets/auth/bg/${localCountry}.avif`)
      .then(t => setAvifSrc(t.default))
      .catch(console.error);

    import(`../../../../../assets/auth/bg/${localCountry}.webp`)
      .then(t => setWebpSrc(t.default))
      .catch(console.error);

    import(`../../../../../assets/auth/bg/${localCountry}.jpg`)
      .then(t => setJpgSrc(t.default))
      .catch(console.error);
  }, [localCountry]);

  const classNames = cx(styles.layoutBg, className, {
    [styles[`layoutBg_country-${localCountry}`]]: localCountry,
  });

  return (
    <div className={classNames}>
      {avifSrc && webpSrc && jpgSrc && (
        <picture>
          <source type="image/avif" srcSet={avifSrc} />
          <source type="image/webp" srcSet={webpSrc} />
          <img src={jpgSrc} alt="" />
        </picture>
      )}
    </div>
  );
};

export { PageLayoutAuthBg };
